import { render, staticRenderFns } from "./kfw.vue?vue&type=template&id=6ab1e13e&scoped=true&"
var script = {}
import style0 from "./kfw.vue?vue&type=style&index=0&id=6ab1e13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab1e13e",
  null
  
)

export default component.exports